import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useTicketAccess } from '../../hooks/tickets/useTicketAccess'
import Loading from '../../pages/Loading'

export default function TicketAccessGuard({ children }: { children: ReactNode }) {
  const { isRoleResolved, canAccessTickets } = useTicketAccess()
  if (!isRoleResolved) return <Loading />
  return canAccessTickets ? <>{children}</> : <Navigate to="/user/home" replace />
}
